import React from "react";
import { UnidadeSaudeDetailsPage } from "./unidadeSaudeDetails.page";
import { UnidadeSaudeDetailsProvider } from "./context/unidade-saude-details-context";

export function UnidadeSaudeDetailsFactory() {
    return (
        <UnidadeSaudeDetailsProvider>
            <UnidadeSaudeDetailsPage />
        </UnidadeSaudeDetailsProvider>
    );
}
